import { autoAddRemoveBy } from "../../cpcoc/autoAddRemoveBy";
import { ArchaeologyAndTheBibleMarch31 } from "./ArchaeologyAndTheBibleMarch31";
export function upcomingBibleClassAnnouncements() {
    autoAddRemoveBy(new Date("March 24, 2024"), new Date("March 31, 2024"), () => ArchaeologyAndTheBibleMarch31("Starting next Sunday in back classroom"));
}
